import { initializeApp } from "firebase/app";
import {
  getAuth,
  setPersistence,
  browserSessionPersistence,
  signOut,
} from "firebase/auth";
import { getFirestore } from "firebase/firestore";
import { getStorage } from "firebase/storage";

// Configuração do Firebase
const firebaseConfig = {
  apiKey: "AIzaSyDRaC_HDvJPwL6BBFA7-q8wG8YOXdCC6Dw",
  authDomain: "prontuario-transplantes.firebaseapp.com",
  projectId: "prontuario-transplantes",
  storageBucket: "prontuario-transplantes.firebasestorage.app",
  messagingSenderId: "400336387006",
  appId: "1:400336387006:web:0bac6ff6a2816516a957ef",
};

// Inicializar Firebase
const app = initializeApp(firebaseConfig);

// Inicializar serviços
export const auth = getAuth(app);
export const db = getFirestore(app);
export const storage = getStorage(app);

// ============================================
// 🔒 SEGURANÇA: Logout por navegação externa
// ============================================
// Threshold de 30 segundos — evita falsos positivos em:
// - Downloads de PDF (3-5 segundos)
// - Diálogos de salvar arquivo (5-15 segundos)
// - Trocar de aba no navegador (instantâneo)
// Mas detecta navegação real para outro site (>30s fora)
// ============================================

const CHAVE_NAVEGACAO = "hepato_ultima_atividade";
const THRESHOLD_LOGOUT = 30000; // 30 segundos

// Ao carregar a página, verificar se estava fora por muito tempo
const ultimaAtividade = localStorage.getItem(CHAVE_NAVEGACAO);
if (ultimaAtividade) {
  const tempoFora = Date.now() - parseInt(ultimaAtividade);
  if (tempoFora > THRESHOLD_LOGOUT) {
    console.log(`🔒 [Firebase] Fora por ${Math.round(tempoFora / 1000)}s — marcando para logout`);
    localStorage.setItem("hepato_deve_deslogar", "true");
  }
}

// Atualizar timestamp a cada 5 segundos (não 500ms)
localStorage.setItem(CHAVE_NAVEGACAO, Date.now().toString());
setInterval(() => {
  localStorage.setItem(CHAVE_NAVEGACAO, Date.now().toString());
}, 5000);

// ⚠️ SEGURANÇA: Sessão expira ao fechar o navegador
setPersistence(auth, browserSessionPersistence)
  .then(() => {
    console.log("✅ Persistência configurada: SESSION (logout ao fechar navegador)");

    // Verificar se deve deslogar por navegação externa
    const deveDeslogar = localStorage.getItem("hepato_deve_deslogar");
    if (deveDeslogar === "true") {
      console.log("🔒 [Firebase] Executando logout por navegação externa...");
      localStorage.removeItem("hepato_deve_deslogar");
      signOut(auth);
    }
  })
  .catch((error) => {
    console.error("❌ Erro ao configurar persistência:", error);
  });

export default app;